module.exports = __webpack_public_path__ + "static/media/hls.3a505c50.png";